export const NAVIGATION_TABNAMES = {
  ACTIVITY: 'Activity',
  VIDEOS: 'Videos',
  FILES: 'Files',
  POLLS: 'Polls',
  PHOTOS: 'Photos',
}
